module.exports = __webpack_public_path__ + "67cad3e702111dcd7677a630d59442b6.svg";